import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from 'router/routes'

Vue.use(VueRouter)

export const router = new VueRouter({
  scrollBehavior: () => {
    return false
  },
  mode: 'history',
  routes // short for routes: routes
})



/** WEBPACK FOOTER **
 ** ./src/router/index.js
 **/